import React, { useState } from 'react';

export default function QuickActions({ navigate }) {
  const [open, setOpen] = useState(false);

  const actions = [
    { label: 'New Gift Card', icon: 'fa-gift', color: '#10B981', path: '/dashboard/gift-cards?action=new-card' },
    { label: 'New Transaction', icon: 'fa-exchange-alt', color: '#3B82F6', path: '/dashboard/gift-cards?action=new-transaction' },
  ];

  return (
    <div className="quick-actions">
      {open && actions.map((a, i) => (
        <div key={i} className="quick-action-sub" style={{ animation: `fadeIn 0.2s ease ${i * 0.05}s both` }}>
          <span className="label">{a.label}</span>
          <button
            style={{ background: a.color }}
            onClick={() => { navigate(a.path); setOpen(false); }}
          >
            <i className={`fas ${a.icon}`}></i>
          </button>
        </div>
      ))}
      <button
        className="quick-action-btn primary"
        onClick={() => setOpen(o => !o)}
        style={{ transform: open ? 'rotate(45deg)' : 'rotate(0)', transition: 'transform 0.2s' }}
      >
        <i className="fas fa-plus"></i>
      </button>
      <style>{`@keyframes fadeIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
}
